module.exports = "/assets/data/f3559453e6514de13662ca15516cbdb5-CH7.data.json";